module.exports = __webpack_public_path__ + "static/media/tech-icon-tablet.cd8931a2.svg";